import {
  applyRegionSpecificUnits,
  isSizeLabelInStandardFormat,
} from '@pageFeatures/design/designUpload/components/utils/formatOptionLabel'
import { TFieldSpecification } from '@utils/form/hubspot/schema'
import { ReactNode } from 'react'

const isSizeField = (fieldName: string) => {
  return fieldName?.toLowerCase()?.includes('size')
}

// We use ".some" instead of ".every" since plus size options can contain custom fields, like e.g. "Custom size" that won't maintain the standard format
const canDisplayRegionSpecificUnits = (options) =>
  options?.some((option) => isSizeLabelInStandardFormat(option?.displayLabel))

const getFormattedOptions = <
  T extends { displayLabel: string | ReactNode } & Record<string, any>
>(
  field: TFieldSpecification,
  options: T[],
  selectedOption: T | undefined,
  fieldModifiers: Record<string, any>
): [T[], T | undefined] => {
  if (isSizeField(field?.name) && canDisplayRegionSpecificUnits(options)) {
    const formattedOptions = options.map((option) => ({
      ...option,
      displayLabel: applyRegionSpecificUnits({
        optionName: 'size',
        label: String(option.displayLabel),
        fieldModifiers: fieldModifiers,
      }),
    }))

    const formattedSelectedOption = selectedOption
      ? {
          ...selectedOption,
          displayLabel: applyRegionSpecificUnits({
            optionName: 'size',
            label: String(selectedOption.displayLabel),
            fieldModifiers: fieldModifiers,
          }),
        }
      : undefined

    return [formattedOptions, formattedSelectedOption]
  }

  return [options, selectedOption]
}

export { getFormattedOptions, isSizeField, canDisplayRegionSpecificUnits }
